(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/base/assets/javascripts/base.js') >= 0) return;  svs.modules.push('/components/tur/base/assets/javascripts/base.js');

'use strict';

svs.tur = svs.tur || {};
svs.tur.Base = class Base {
  constructor() {
    this.className = '';
    _.extend(this, ...arguments);
    this.callbacks = {};
    this.callback_once = {};
    this.log = new svs.core.log.Logger('tur:base');
    this.elements = [];
    this.$el = this.createElement();
    this.classNames && this.addClass(...this.classNames());
    this._id = "_".concat(Math.random().toString(36).substr(2, 9));
  }
  createElement(className) {
    let tagName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';
    const element = document.createElement(tagName);
    element.className += className ? "".concat(this.className && "".concat(this.className, "-")).concat(className) : this.className;
    this.elements.push(element);
    return element;
  }
  createAndAddElement(_ref) {
    let _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$tagName = _ref.tagName,
      tagName = _ref$tagName === void 0 ? 'div' : _ref$tagName,
      _ref$appendTo = _ref.appendTo,
      appendTo = _ref$appendTo === void 0 ? this.$el : _ref$appendTo;
    const el = this.createElement(className, tagName);
    appendTo.appendChild(el);
    return el;
  }
  addClass() {
    for (let i = 0; i < arguments.length; i++) {
      this.$el.classList.add(arguments[i]);
    }
  }
  removeClass() {
    for (let i = 0; i < arguments.length; i++) {
      this.$el.classList.remove(arguments[i]);
    }
  }
  trigger(event, data) {
    if (event) {
      if (this.callbacks && this.callbacks[event]) {
        this.callbacks[event].forEach(callback => {
          callback.callback.call(callback.context, data);
        });
      }
      if (this.callback_once && this.callback_once[event]) {
        this.callback_once[event].forEach(callback => {
          callback.callback.call(callback.context, data);
          this.callback_once[event] = null;
        });
      }
    } else {
      this.log.error('You passed no event');
    }
  }
  on(event, callback, context) {
    if (!this.callbacks[event]) {
      this.callbacks[event] = [];
    }
    this.callbacks[event].push({
      context,
      callback
    });
  }
  one(event, callback, context) {
    if (!this.callback_once[event]) {
      this.callback_once[event] = [];
    }
    this.callback_once[event].push({
      context,
      callback
    });
  }
  off(event, context) {
    if (this.callbacks[event]) {
      for (let i = 0; i < this.callbacks[event].length; i++) {
        const item = this.callbacks[event][i];
        if (item.context === context) {
          this.callbacks[event].splice(i, 1);
          break;
        }
      }
    }
  }
  error(msg) {
    this.log.error(msg);
  }
  destroy() {
    this.callbacks = {};
    this.callback_once = {};
    for (let i = 0; i < this.elements.length; i++) {
      if (this.elements[i].remove) {
        this.elements[i].remove();
      } else {
        this.el.style.display = 'none';
      }
    }
  }
  getAbsoluteHeight(el) {
    el = typeof el === 'string' ? document.querySelector(el) : el;
    const styles = window.getComputedStyle(el),
      margin = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
    return Math.ceil(el.offsetHeight + margin);
  }
  getAbsoluteWidth(el) {
    el = typeof el === 'string' ? document.querySelector(el) : el;
    const styles = window.getComputedStyle(el),
      margin = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
    return Math.ceil(el.offsetWidth + margin);
  }
};

 })(window);